import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { MaterialCatalogPage } from "src/routes/libraries/material-catalog/MaterialCatalogPage";
import { MaterialCostPage } from "src/routes/libraries/material-catalog/MaterialCostPage";
import { MaterialPage } from "src/routes/libraries/material-catalog/MaterialPage";
import { InstallTasksPage } from "src/routes/libraries/material-catalog/install-tasks/InstallTasksPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as materialCatalogPaths from "src/routing/domains/libraries/material-catalog/materialCatalogPaths";

/**
 * `/libraries/material-catalog/*` route tree.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (legacy `PageHeader` chrome).
 *
 * Static paths (`add`, `install-tasks`) and the nested `:variantId/cost` path are registered before
 * the bare `:variantId` details route.
 */
export const materialCatalogRoutes: RouteObject = {
  path: materialCatalogPaths.materialsCatalogRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { index: true, Component: MaterialCatalogPage },
            { path: materialCatalogPaths.materialCreateRoute.path, Component: MaterialPage },
            { path: materialCatalogPaths.installTasksRoute.path, Component: InstallTasksPage },
            { path: materialCatalogPaths.materialCostRoute.path, Component: MaterialCostPage },
            { path: materialCatalogPaths.materialDetailsRoute.path, Component: MaterialCatalogPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
